export default __webpack_public_path__ + "static/media/icon_app-gallery.04931b78-2.c171d56a.svg";